import { CoverageTypeEnum } from "@platform/types";

/**
 * Coverage heading labels and canonical order for the Needs Review Comments
 * drawer, per the user story's acceptance criteria — deliberately its own
 * vocabulary rather than `coverageTypeToLabel` ("Short Term Disability",
 * "Basic Life AD&D") or `compsCoverageDisplayName` ("Vol Life & AD&D"),
 * neither of which matches the AC's exact strings.
 */
export const COVERAGE_HEADING_ORDER: readonly CoverageTypeEnum[] = [
  CoverageTypeEnum.DENTAL,
  CoverageTypeEnum.VISION,
  CoverageTypeEnum.STD,
  CoverageTypeEnum.LTD,
  CoverageTypeEnum.BASIC_LIFE_ADND,
  CoverageTypeEnum.VOLUNTARY_LIFE_ADND,
  CoverageTypeEnum.ACCIDENT,
  CoverageTypeEnum.CRITICAL_ILLNESS,
  CoverageTypeEnum.HOSPITAL_INDEMNITY,
  CoverageTypeEnum.CANCER,
  CoverageTypeEnum.FMLA,
  CoverageTypeEnum.EAP,
  CoverageTypeEnum.INDIVIDUAL_DISABILITY_INSURANCE,
  CoverageTypeEnum.WHOLE_LIFE,
];

export const COVERAGE_HEADING_LABEL: Record<CoverageTypeEnum, string> = {
  [CoverageTypeEnum.DENTAL]: "Dental",
  [CoverageTypeEnum.DENTAL_PPO]: "Dental",
  [CoverageTypeEnum.DENTAL_HMO]: "Dental",
  [CoverageTypeEnum.VISION]: "Vision",
  [CoverageTypeEnum.STD]: "STD",
  [CoverageTypeEnum.LTD]: "LTD",
  [CoverageTypeEnum.BASIC_LIFE_ADND]: "Basic Life & AD&D",
  [CoverageTypeEnum.VOLUNTARY_LIFE_ADND]: "Voluntary Life & AD&D",
  [CoverageTypeEnum.ACCIDENT]: "Accident",
  [CoverageTypeEnum.CRITICAL_ILLNESS]: "Critical Illness",
  [CoverageTypeEnum.HOSPITAL_INDEMNITY]: "Hospital Indemnity",
  [CoverageTypeEnum.CANCER]: "Cancer",
  [CoverageTypeEnum.FMLA]: "FMLA",
  [CoverageTypeEnum.EAP]: "EAP",
  [CoverageTypeEnum.INDIVIDUAL_DISABILITY_INSURANCE]: "IDI",
  [CoverageTypeEnum.WHOLE_LIFE]: "Whole Life",
};

/**
 * Dental PPO and Dental HMO are separate Quotes/SBS pages (and separate
 * stored LOC coverage types), but Responses and Comps plan groups carry the
 * base "dental" coverage type — so both variants share the "Dental" heading
 * and are told apart by their plan-group card label instead.
 */
export const normalizeToHeadingCoverageType = (
  coverageType: string,
): CoverageTypeEnum | undefined => {
  if (
    coverageType === CoverageTypeEnum.DENTAL_PPO ||
    coverageType === CoverageTypeEnum.DENTAL_HMO
  ) {
    return CoverageTypeEnum.DENTAL;
  }
  return COVERAGE_HEADING_ORDER.find((type) => type === coverageType);
};

export const NETWORK_LABEL: Record<string, string> = {
  inNetwork: "In Network",
  outOfNetwork: "Out of Network",
};

export const COMPS_SECTION_LABEL = "Comps";
export const RESPONSES_SECTION_LABEL = "Responses";
